export default __webpack_public_path__ + "static/media/legend_yellow_popup.30b507d4.png";